import { CaseManagerConfiguration } from "types/AppConfig";
import { Dossier } from "types/Dossier";
import { PlaybackControls } from "./PlaybackControls";
import { PlaybackDebugControls } from "./PlaybackDebugControls";
import { FeatureFlagGuard } from "features/appFeatures/FeatureFlagGuard";
import { AppFeature } from "features/appFeatures/types/AppFeature";
import { PlaybackDeviceGrid } from "./PlaybackDeviceGrid";
import { CaseViewerUserSettingsLoader } from "./CaseViewerUserSettingsLoader";

export interface PlaybackProps {
    drawerWidth: number;
    dossier?: Dossier;
    caseManagerConfiguration?: CaseManagerConfiguration;
}

export function Playback(props: PlaybackProps) {
    const { dossier, caseManagerConfiguration, drawerWidth } = props;

    return dossier?.startTime &&
        dossier?.endTime &&
        dossier?.siteId &&
        caseManagerConfiguration ? (
        <>
            <FeatureFlagGuard
                accessibleWithFeatureFlags={[AppFeature.AdminDebugTools]}
            >
                <PlaybackDebugControls />
                <CaseViewerUserSettingsLoader />
            </FeatureFlagGuard>

            <PlaybackDeviceGrid
                dossierId={dossier.id}
                dossierCapabilityNames={dossier.dossierCapabilityNames}
                siteId={dossier.siteId}
                drawerWidth={props.drawerWidth}
            />
            <PlaybackControls
                startDateTime={dossier.startTime}
                endDateTime={dossier.endTime}
                caseManagerConfiguration={caseManagerConfiguration}
                drawerWidth={drawerWidth}
                displayAsFloatingFooter={true}
            />
        </>
    ) : undefined;
}
